<template>
    <!-- Testimonials -->
    <section class="section our-testimonials">
        <div class="container">
            <div class="section-heading aos" data-aos="fade-up">
                <h2><span>Đánh giá về EZBadminton</span></h2>
                <p class="sub-title">
                    Nền tảng quản lý giải đấu chuyên nghiệp, được tin dùng bởi cộng đồng yêu thích cầu lông trên toàn thế giới.
                    Chúng tôi mang đến giải pháp toàn diện, từ tổ chức, thi đấu đến cập nhật kết quả,
                    giúp nâng tầm trải nghiệm thể thao của bạn.
                </p>
            </div>
            <div class="row">
                <div class="featured-slider-group aos" data-aos="fade-up">
                    <div class="owl-carousel testimonial-slide featured-venues-slider owl-theme">
                        <!-- Testimonials Item -->
                        <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
                            <Slide v-for="item in Testimonials" :key="item.id">
                                <div class="testimonial-group">
                                    <div class="testimonial-review text-start">
                                        <div class="rating-point">
                                            <i v-for="star in 5" :key="star" class="fas fa-star" :class="{ filled: star <= item.rating }"></i>
                                            <span> {{ item.rating }} </span>
                                        </div>
                                        <h5>{{ item.name }}</h5>
                                        <p>{{ item.content }}</p>
                                    </div>
                                    <div class="listing-venue-owner">
                                        <a class="navigation">
                                            <img :src="item.image" alt="User">
                                        </a>
                                        <div class="testimonial-content">
                                            <h5><a href="javascript:;">{{ item.name }}</a></h5>
                                            <a href="javascript:void(0);" class="btn btn-primary">
                                                {{ item.position }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </Slide>
                            <template #addons>
                                <Navigation />
                            </template>
                        </Carousel>
                        <!-- /Testimonials Item -->
                    </div>
                </div>
                <!-- Testimonials Slide -->
                <div class="brand-slider-group aos" data-aos="fade-up">
                    <home-slide></home-slide>
                </div>
                <!-- /Testimonials Slide -->
            </div>
        </div>
    </section>
    <!-- /Testimonials -->
</template>

<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import axios from "axios";
import { getTestimonials } from "@/api/strapi/testimonial";
import { getImageUrl } from "@/api/strapi/image";

export default {
    data() {
        return {
            Testimonials: [],
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            breakpoints: {
                575: { itemsToShow: 2, snapAlign: "center" },
                767: { itemsToShow: 2, snapAlign: "center" },
                991: { itemsToShow: 2, snapAlign: "center" },
                1024: { itemsToShow: 3, snapAlign: "start" },
            },
        };
    },
    async created() {
        await this.fetchTestimonial();
    },
    methods: {
        async fetchTestimonial() {
            try {
                const response = await getTestimonials();
                this.Testimonials = response.data.map((item) => {
                    return {
                        id: item.id,
                        name: item.name,
                        content: item.content,
                        rating: item.rating || 5, // Mặc định là 5 nếu không có
                        image: item.media
                        ? getImageUrl(item.media.url)
                        : '',
                        position: item.position
                    };
                });
            } catch (error) {
                console.error("Lỗi lấy dữ liệu testimonials:", error);
            }
        },
    },
    components: {
        Carousel,
        Slide,
        Navigation,
    },
};
</script>
